import { motion } from "framer-motion";

const PREVIEWS = [
  {
    url: "https://images.unsplash.com/photo-1611974789855-9c2a0a7236a3?crop=entropy&cs=srgb&fm=jpg&w=900&q=80",
    title: "Reading Candlestick Patterns",
    desc: "Visual breakdowns of every major pattern — from doji to engulfing — and what each one signals.",
  },
  {
    url: "https://images.unsplash.com/photo-1590283603385-17ffb3a7f29f?crop=entropy&cs=srgb&fm=jpg&w=900&q=80",
    title: "Building Entry & Exit Plans",
    desc: "Step-by-step templates to plan a trade before you ever click the buy button.",
  },
  {
    url: "https://images.unsplash.com/photo-1651341050677-24dba59ce0fd?crop=entropy&cs=srgb&fm=jpg&w=900&q=80",
    title: "Risk Management Worksheets",
    desc: "Position-size calculators and stop-loss frameworks you can use on every single trade.",
  },
  {
    url: "https://images.unsplash.com/photo-1640340434855-6084b1f4901c?crop=entropy&cs=srgb&fm=jpg&w=900&q=80",
    title: "Understanding Market Structure",
    desc: "Liquidity, volatility, and how the big players move price — explained for beginners.",
  },
];

export default function Inside() {
  return (
    <section
      id="inside"
      data-testid="inside-section"
      className="relative py-24 md:py-32 bg-[#070707] border-y border-white/5"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 0.6 }}
          className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-14"
        >
          <div>
            <div className="text-emerald-400 uppercase tracking-[0.3em] text-xs font-semibold font-display mb-4">
              Inside the Ebook
            </div>
            <h2 className="font-display font-bold text-white text-4xl sm:text-5xl lg:text-6xl tracking-tighter leading-[1.05]">
              A peek inside <br className="hidden md:block" />
              <span className="text-emerald-400">the pages.</span>
            </h2>
          </div>
          <p className="text-white/60 max-w-md text-base">
            Each chapter is built around clear visuals. No walls of text — just charts, examples,
            and practical worksheets.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8">
          {PREVIEWS.map((p, i) => (
            <motion.div
              key={p.title}
              data-testid={`inside-preview-${i}`}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-50px" }}
              transition={{ duration: 0.6, delay: i * 0.08 }}
              className={`group relative rounded-3xl overflow-hidden border border-white/10 bg-[#0c0c0c] hover:border-emerald-500/30 transition-all duration-500 ${
                i % 2 === 0 ? "md:translate-y-0" : "md:translate-y-10"
              }`}
            >
              <div className="aspect-[16/10] overflow-hidden relative">
                <img
                  src={p.url}
                  alt={p.title}
                  loading="lazy"
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black via-black/30 to-transparent" />
                <div className="absolute top-4 left-4 text-[10px] font-display tracking-[0.25em] uppercase px-2.5 py-1 rounded-full bg-black/60 border border-white/10 text-emerald-300">
                  Chapter {i + 1}
                </div>
              </div>
              <div className="p-6 md:p-7">
                <h3 className="font-display font-semibold text-white text-xl md:text-2xl tracking-tight">
                  {p.title}
                </h3>
                <p className="mt-2 text-white/55 text-sm md:text-base leading-relaxed">{p.desc}</p>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
